export const hashToObject = (hash) => {
  const hashObject = {};
  hash.split('&').forEach((item) => {
    const [key, value] = item.split('=');
    hashObject[key] = value;
  });
  return hashObject;
};

export const getPWADisplayMode = () => {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  if (document.referrer.startsWith('android-app://')) {
    return 'twa';
  }
  if (navigator.standalone || isStandalone) {
    return 'standalone';
  }
  return 'browser';
};

export const captureAsyncThunkError = (_, action) => {
  throw new Error(action.error.stack)
}
